import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  fill: "currentColor",
  cx: 10,
  cy: 10,
  r: 9
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-13a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1m0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
});

var SvgCircleAlertMajorTwotone = function SvgCircleAlertMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgCircleAlertMajorTwotone as S };
